<template>
  <div :class="`offers__offer offers__offer--${format.slug}`">
    <div class="offers__icon">
      <img :src="`${assetPath}${format.icon}`" alt="">
    </div>
    <h2>{{ format.name }}</h2>
    <p
      v-if="pageMode === 'suppliers'"
      v-html="format.supplierCopy"
    ></p>
    <p
      v-if="pageMode === 'managers'"
      v-html="format.managerCopy"
    ></p>
    <!-- <div v-if="pageMode === 'suppliers'">
      <h3>Best For: </h3>
      <ul class="offers__tags">
        <li v-for="(tag, index) in tags" :key="index">
          {{ tag }}
        </li>
      </ul>
    </div> -->
    <template v-if="format.phsyical">
      <button
        type="button"
        class="button button--green"
        @click="pickOffer(format.slug)"
        aria-controls="product-results" 
      >
        {{ buttonText }}
      </button>
    </template>
    <template v-if="!format.physical">
      <button
        type="button"
        v-if="!unlocked && !format.download"
        class="button button--disabled"
        @click="unlock"
      >
        {{ buttonText }}
      </button>
      <a
        v-if="format.download"
        :href="`${assetPath}${format.download}`"
        type="button"
        class="button button--green"
        target="_blank"
        data-gtmcat="OCS Engagement" data-gtmaction="download" :data-gtmlabel="format.slug"
        download
      >
        Download {{ format.shortName }}
      </a>
      <a
        v-if="unlocked && !format.download"
        :href="format.link"
        type="button"
        class="button button--green"
        data-gtmcat="OCS Engagement" data-gtmaction="click" :data-gtmlabel="format.slug"
      >
        {{ buttonText }}
      </a>
    </template>
  </div>
</template>

<script>
import zenscroll from 'zenscroll'
import { assetPath } from '../../mixins/assetPath.js'
import { pageMode } from '../../mixins/pageMode.js'
// import iconFilterPack from '@/assets/icons/offerIcons_FilterPack.svg'
// import iconFractionPacks from '@/assets/icons/offerIcons_FractionPacks.svg'
// import iconRoastGround from '@/assets/icons/offerIcons_RoastGround.svg'
// import iconSelectBrew from '@/assets/icons/offerIcons_SelectBrew.svg'
// import iconWholeBean from '@/assets/icons/offerIcons_WholeBean.svg'

export default {
  name: 'Offer',
  components: {
    // iconFilterPack,
    // iconFractionPacks,
    // iconRoastGround,
    // iconSelectBrew,
    // iconWholeBean,
  },
  props: {
    format: {
      type: Object,
      default: () => {}
    },
    tags: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    unlocked() {
      return this.$store.state.offersUnlocked
    },
    buttonText() {
      if (this.unlocked) {
        return this.format.link ? 'Start Now' : `Download ${this.format.shortName}`
      } else {
        return 'Unlock'
      }
    },
  },
  methods: {
    pickOffer(offer) {
      // console.log('offer', offer);
      // eslint-disable-next-line
      if (typeof dataLayer === 'object') {
        // eslint-disable-next-line
        dataLayer.push({
          event: 'genericEvent',
          eventCat: 'OCS Engagement',
          eventAction: 'click',
          eventLabel: 'offer Choice | ' + offer,
        });
      }
      // setTimeout(() => zenscroll.to(document.getElementById('products-wrapper')), 500)
    },
    unlock() {
      zenscroll.to(document.querySelector('body'))
    }
  },
  mixins: [assetPath, pageMode]
}
</script>

<style lang="scss">
  .offers__offer {
    flex: 1 1 auto;
    text-align: center;
    background-color: white;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
    align-items: center;
    padding: 1.5em 1em 2em 1em;
    p {
      color: $lgrayer;
      max-width: 32em;
      margin-left: auto;
      margin-right: auto;
      flex: 1 1 auto;
    }
    h2 {
      font-size: 18px;
      font-weight: 900;
      text-transform: uppercase;
      line-height: 1;
      color: $lgrayer;
      margin: 0.25em auto 0.5em auto;
    }
    h3 {
      margin: 0.5em 0 0.25em 0;
      font-weight: 600;
      font-size: 1em;
      font-family: $serif;
    }
  }
  
  .offers__icon {
    width: 100px;
    // margin-bottom: 0.25em;
    margin-bottom: 0.5em;
  }
  .offers__offer--select-brew {
    .offers__icon {
      width: 135px;
      // margin-bottom: 0.75em;
    }
  }
  .offers__tags {
    list-style: none;
    margin: 0 0 1em 0;
    padding: 0;
    display: flex;
    align-items: center;
    & > li {
      background-color: rgba($blue, 0.25);
      padding: 0.5em 0.75em 0.6em 0.75em;
      font-size: 0.875em;
      margin: 0.5em;
    }
  }
</style>